import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import {ComponentCanDeactivate} from './component-can-deactivate';
import {formstate} from '../../reducers';
import {I18n} from '@ngx-translate/i18n-polyfill';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {

  constructor(
    private i18n: I18n
  ) {}

  canDeactivate(component: ComponentCanDeactivate): boolean {
    if(formstate.getverif()) {
      if (confirm(this.i18n({value: 'You have unsaved changes! If you leave, your changes will be lost..', id: 'FormDetectUnsavedChange'}))) {
        formstate.setverif(false);
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/can-deactivate/can-deactivate.guard.ts